import AxiosClient from "../../../services/axios.services";

class EvaluationMonitorServices {
  getEvaluationMonitor = (params) =>
    AxiosClient.get("/api/app/monitor_evaluacion/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });

  getEvaluationMonitorById = (id) =>
    AxiosClient.get(`/api/app/monitor_evaluacion/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });

  getQuestionFactor = (params) =>
    AxiosClient.get(
      "/api/app/evaluacion_despliegue_preguntas_factor_plantilla/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );

  getQuestionCompetency = (params) =>
    AxiosClient.get(
      "/api/app/evaluacion_despliegue_preguntas_competencia_plantilla/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );

  getMetricaCompetencia = (params) =>
    AxiosClient.get("/api/app/evaluacion_metrica_competencia/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });

  getMetricByFactor = (params) =>
    AxiosClient.get("/api/app/evaluacion_metrica_factor/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });

  saveEvaluationMonitor = (data) =>
    AxiosClient.post("/api/app/monitor_evaluacion/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editEvaluationMonitor = (id, data) =>
    AxiosClient.put(`/api/app/monitor_evaluacion/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  editEvaluationMonitorNotAccept = (data) =>
    AxiosClient.post("/api/app/evaluacion_no_aceptada_x_usuario/", data, {
      headers: { "Content-Type": "application/json" },
    });
  saveEvaluationMonitorGD = (data) =>
    AxiosClient.post("/api/app/evaluacion_archivo_plan_accion/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editEvaluationMonitorGD = (id, data) =>
    AxiosClient.put(`/api/app/evaluacion_archivo_plan_accion/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  updateBoss = (data) =>
    AxiosClient.post(
      `/api/app/actualizacion_jefe_evaluaciones_casos_especiales/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteEvaluationMonitor = (data) =>
    AxiosClient.post(
      `/api/app/eliminacion_evaluaciones_casos_especiales/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  mailSendEvaluationMonitor = (data) =>
    AxiosClient.post("/api/app/correo_evaluaciones/", data, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new EvaluationMonitorServices();
